import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const UsersModule = lazy(loadModule);

export default UsersModule;
